import $ from 'jquery'

export default {
    init () {
    // JavaScript to be fired on the home page
        let wHeight = $(window).height();

        $('.scroll-down').on('click', function (e) {
            e.preventDefault();

            $('html, body').animate(
                { scrollTop: wHeight },
                500,
                'linear'
            )
        })
    },
    finalize () {
    // JavaScript to be fired on the home page, after the init JS
    }
}
